module.exports = __webpack_public_path__ + "img/ico-card-active.53b81510.svg";